/* global axios */
import ApiClient from './ApiClient';

class ProductOrdersAPI extends ApiClient {
  constructor() {
    super('product_orders', { accountScoped: true });
  }

  start(id) {
    return axios.patch(`${this.url}/${id}/start`);
  }

  advance(id) {
    return axios.patch(`${this.url}/${id}/advance`);
  }

  complete(id) {
    return axios.patch(`${this.url}/${id}/complete`);
  }

  cancel(id) {
    return axios.patch(`${this.url}/${id}/cancel`);
  }

  executeAction(actionId) {
    return axios.patch(`${this.baseUrl()}/product_order_actions/${actionId}/execute`);
  }
}

export default new ProductOrdersAPI();
